import { createAction, props } from '@ngrx/store';

export const EnablePendingAction = createAction('[Pending] Enable');

export const DisablePendingAction = createAction('[Pending] Enable');
